import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import AppTheme from './shared-theme/AppTheme';
import {
  AppBar,
  Noticias,
  Gestiones,
  Gobernanza,
  NuestraHistoria,
  Contactos,
  Footer,
  ContactsContainer,
  ScrollToTop,
  LandscapeWarning
} from './components';
import GlobalDialog from './components/FullScreenDialog/GlobalDialog';
import { AuthProvider } from './context/AuthContext';
import { TranslationProvider } from './context/TranslationContext';
import './App.css';

function AppContent() {
  return (
    <AppTheme>
      <CssBaseline enableColorScheme />
      <Router>
        <LandscapeWarning />
        <ScrollToTop />
        <AppBar />
        <Box sx={{ minHeight: "calc(100dvh - 250px)", my: { xs: 18, md: 20 }, }}>
          <Routes>
            <Route path="/" element={<></>} />
            <Route path="/noticias" element={<Noticias />} />
            <Route path="/gestiones" element={<Gestiones />} />
            <Route path="/gobernanza" element={<Gobernanza />} />
            <Route path="/contactos" element={<Contactos />} />
            <Route path="/nuestra-historia" element={<NuestraHistoria />} />
          </Routes>
        </Box>
        <Footer />
        <ContactsContainer />
      </Router>
    </AppTheme>
  );
}

export default function App() {
  return (
    <TranslationProvider>
      <AuthProvider>
        <GlobalDialog>
          <AppContent />
        </GlobalDialog>
      </AuthProvider>
    </TranslationProvider>
  );
}
